import { useContext } from 'react';
import { NetworkEnvContext } from '@providers/NetworkEnvProvider';

const useNetworkEnv = () => useContext(NetworkEnvContext);

export default useNetworkEnv;
